import axios from 'axios';
import json from './countryData.json';

const basePath = 'https://restcountries.com/v3.1';

const appBasePath = '/web-api/countries';

export const get = (payload, config = {}) => {
    return axios.get(
        basePath + '/' + payload,
        config
    );
   
}

export const search = (payload, config = {}) => {

    return axios.get(
        basePath + '/name/'+ payload,
        config
    );
}

export const availableCountry = ( payload, config = {}) => {

    return axios.get(
        appBasePath,
        config
    );
}

export const CountryData = () => {
    return json;
}



export default {
    get,
    search,
    availableCountry,
    CountryData,
}